var map = {
	"./adminDashboard": 95,
	"./adminDashboard.js": 95,
	"./discover": 1874,
	"./discover.js": 1874,
	"./home": 3768,
	"./home.js": 3768,
	"./login": 7400,
	"./login.js": 7400,
	"./message": 6290,
	"./message/": 6290,
	"./message/[id]": 9667,
	"./message/[id].js": 9667,
	"./message/index": 6290,
	"./message/index.js": 6290,
	"./post/[id]": 6161,
	"./post/[id].js": 6161,
	"./profile/[id]": 8946,
	"./profile/[id].js": 8946,
	"./register": 8407,
	"./register.js": 8407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;